/**
 * One glyph per truck-catalog category, mirroring the shipper app's
 * per-category icons (closed box truck / open flatbed / articulated
 * trailer / reefer). Shared by the shipment form's truck picker and the
 * shipment detail view.
 */
const CATEGORY_ICON_PATHS: Record<string, string> = {
  // Material "local shipping" — closed box truck
  closed_container:
    'M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z',
  // open bed with low walls + cab
  open_flatbed:
    'M1 11h2v2h9v-2h2v5H1v-5zm15-2h3.2L23 13.1V16h-7V9zM5.5 20c-1 0-1.8-.8-1.8-1.8S4.5 16.5 5.5 16.5s1.8.8 1.8 1.8S6.5 20 5.5 20zm5.5 0c-1 0-1.8-.8-1.8-1.8s.8-1.7 1.8-1.7 1.8.8 1.8 1.7S12 20 11 20zm7.5 0c-1 0-1.8-.8-1.8-1.8s.8-1.7 1.8-1.7 1.8.8 1.8 1.7S19.5 20 18.5 20z',
  // long low deck trailer + separate cab
  heavy_articulated:
    'M1 12.5h13V16H1v-3.5zM16 8h3.2L23 12.5V16h-7V8zM4 20c-1 0-1.8-.8-1.8-1.8S3 16.5 4 16.5s1.8.8 1.8 1.8S5 20 4 20zm4.5 0c-1 0-1.8-.8-1.8-1.8s.8-1.7 1.8-1.7 1.8.8 1.8 1.7S9.5 20 8.5 20zm10 0c-1 0-1.8-.8-1.8-1.8s.8-1.7 1.8-1.7 1.8.8 1.8 1.7-.8 1.8-1.8 1.8z',
  // Material "ac unit" snowflake — temperature-controlled / special purpose
  special_purpose:
    'M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22z',
};

export function TruckIcon({
  categoryId,
  size = 28,
  className,
}: {
  categoryId: string;
  size?: number;
  className?: string;
}) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d={CATEGORY_ICON_PATHS[categoryId] ?? CATEGORY_ICON_PATHS.closed_container} />
    </svg>
  );
}
